import { render, staticRenderFns } from "./chateau-batard.vue?vue&type=template&id=772f8fc3&scoped=true"
import script from "./chateau-batard.vue?vue&type=script&lang=js"
export * from "./chateau-batard.vue?vue&type=script&lang=js"
import style0 from "./chateau-batard.vue?vue&type=style&index=0&id=772f8fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f8fc3",
  null
  
)

export default component.exports